/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LogAttendanceResponse } from './LogAttendanceResponse';
import {
    LogAttendanceResponseFromJSON,
    LogAttendanceResponseFromJSONTyped,
    LogAttendanceResponseToJSON,
    LogAttendanceResponseToJSONTyped,
} from './LogAttendanceResponse';

/**
 * 
 * @export
 * @interface ResultOfLogAttendanceResponse
 */
export interface ResultOfLogAttendanceResponse {
    /**
     * 
     * @type {LogAttendanceResponse}
     * @memberof ResultOfLogAttendanceResponse
     */
    data: LogAttendanceResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfLogAttendanceResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfLogAttendanceResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfLogAttendanceResponse interface.
 */
export function instanceOfResultOfLogAttendanceResponse(value: object): value is ResultOfLogAttendanceResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfLogAttendanceResponseFromJSON(json: any): ResultOfLogAttendanceResponse {
    return ResultOfLogAttendanceResponseFromJSONTyped(json, false);
}

export function ResultOfLogAttendanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfLogAttendanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LogAttendanceResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfLogAttendanceResponseToJSON(json: any): ResultOfLogAttendanceResponse {
    return ResultOfLogAttendanceResponseToJSONTyped(json, false);
}

export function ResultOfLogAttendanceResponseToJSONTyped(value?: ResultOfLogAttendanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LogAttendanceResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

